export default [
    {
        path: '/roles',
        name: 'PageRolesList',
        meta: { title: 'roles.listTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/roles'),
    },
    {
        path: '/roles/create',
        name: 'PageRolesCreate',
        meta: { title: 'roles.createFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/roles/create'),
    },
    {
        path: '/roles/:id/edit',
        name: 'PageRolesEdit',
        meta: { title: 'roles.editFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/roles/id/edit'),
    },
]